import {Component, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {I18nMessage} from '@app/shared/api/model/i18n';
import {SustainabilityRatingMeasure} from '@app/shared/services/api/sustainability-ratings/measures/sustainability-rating-measures.interface';
import {SustainabilityRatingMeasuresService} from '@app/shared/services/api/sustainability-ratings/measures/sustainability-rating-measures.service';
import {finalize} from 'rxjs';
import {AceSelectComponent} from '../ace-select/ace-select.component';

@Component({
  selector: 'app-sustainability-rating-measures-select',
  templateUrl: './sustainability-rating-measures-select.component.html',
  styleUrls: ['./sustainability-rating-measures-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SustainabilityRatingMeasuresSelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class SustainabilityRatingMeasuresSelectComponent implements OnInit, ControlValueAccessor {
  @Input() options: SustainabilityRatingMeasure[];
  @Input() placeholder: I18nMessage | string = {messageKey: "Measures"};
  @Input() loading: boolean;
  @Input() hideSelected = true;
  @Input() appendTo: string;
  @Output() dataLoaded = new EventEmitter<SustainabilityRatingMeasure[]>();
  @ViewChild(AceSelectComponent, {static: true})
  private aceSelect: AceSelectComponent;

  constructor(private sustainabilityRatingMeasuresService: SustainabilityRatingMeasuresService) {}

  ngOnInit(): void {
    this.loadOptions();
  }

  writeValue(obj: SustainabilityRatingMeasure): void {
    this.aceSelect.writeValue(obj);
  }

  registerOnChange(fn: (measure: SustainabilityRatingMeasure) => void): void {
    this.aceSelect.registerOnChange(fn);
  }

  registerOnTouched(fn: () => void): void {
    this.aceSelect.registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.aceSelect.setDisabledState(isDisabled);
  }

  private loadOptions() {
    if (!this.options) {
      this.loading = true;
      this.sustainabilityRatingMeasuresService.getAllSustainabilityRatingMeasures()
        .pipe(finalize(() => this.loading = false))
        .subscribe(sustainabilityRatingMeasures => {
          this.options = sustainabilityRatingMeasures;
          this.dataLoaded.emit(this.options);
        });
    } else {
      this.dataLoaded.emit(this.options);
    }
  }
}
